import React from "react";
import TablaCanje from "./TablaCanje";

export const Canje = props => <TablaCanje />;

export default Canje;
